// Столбцы таблицы заказчика (ТЗ 6.6) в одном месте: шапка и строки берут отсюда и подписи, и
// ширины, поэтому они не расходятся. Набор — ровно срез заказчика (ТЗ 3.5): ни плановой цены, ни
// персональной скидки, ни вознаграждения, ни комиссии по позиции.
//
// Ширины подобраны так, чтобы все шестнадцать столбцов — включая «Поставщик» и кнопки «Утверждаю» и
// «Отклонить» — помещались на мониторе 1366 px без горизонтальной прокрутки (ревью этапа 9): сумма
// базовых ширин 1222 px при доступных примерно 1300 px (хватает и на 1280 px). `grow` распределяет
// остаток на широких экранах, поэтому на 1600 px таблица занимает всю ширину, а не обрывается.
// Сгенерировано Claude.

/**
 * key — имя столбца, title — подпись, width — базовая (и минимальная) ширина в пикселях,
 * grow — доля свободного места на широком экране (0 — столбец фиксированной ширины).
 */
export const COLUMNS = [
  { key: 'check', title: '', width: 26, grow: 0 },
  { key: 'photo', title: 'Фото', width: 42, grow: 0 },
  { key: 'name', title: 'Наименование', width: 126, grow: 4 },
  { key: 'brand', title: 'Бренд', width: 72, grow: 1 },
  { key: 'article', title: 'Артикул', width: 68, grow: 1 },
  { key: 'room', title: 'Помещение', width: 74, grow: 1 },
  { key: 'quantity', title: 'Кол-во', width: 58, grow: 1 },
  { key: 'status', title: 'Статус', width: 88, grow: 1 },
  { key: 'supplierPrice', title: 'Цена без скидки', width: 84, grow: 1 },
  { key: 'discount', title: 'Скидка, ₽', width: 74, grow: 1 },
  { key: 'discountPercent', title: 'Скидка, %', width: 62, grow: 1 },
  { key: 'customerPrice', title: 'Цена', width: 84, grow: 1 },
  { key: 'customerTotal', title: 'Сумма', width: 86, grow: 1 },
  { key: 'delivery', title: 'Срок поставки', width: 80, grow: 1 },
  { key: 'supplier', title: 'Поставщик', width: 90, grow: 1 },
  { key: 'actions', title: '', width: 108, grow: 0 },
];

const BY_KEY = COLUMNS.reduce((acc, column) => ({ ...acc, [column.key]: column }), {});

/**
 * Инлайновый стиль ячейки: ширина столбца задаётся в одном месте (см. COLUMNS). Столбец не
 * сжимается ниже базовой ширины (под неё же выставлена минимальная ширина таблицы), но
 * растягивается на широком экране пропорционально `grow`.
 */
export function colStyle(key) {
  const column = BY_KEY[key];
  const width = `${column?.width ?? 80}px`;
  return { flex: `${column?.grow ?? 0} 0 ${width}`, minWidth: width };
}

/** Суммарная ширина таблицы — минимальная ширина контейнера с горизонтальной прокруткой. */
export const TOTAL_WIDTH = COLUMNS.reduce((acc, column) => acc + column.width, 0);
